import myAPI from './resources'
import config from '../config.js'
import StorageManager from "../utils/storageManager"
import carbuyservice from "./clients/carBuyService"

export default {
  verifyComplete: async function (id) {
    return await carbuyservice.get("/quote/" + id + "/VerifyComplete", {}, true);
  },
  sendToDispatch: async function (id) {
    return await carbuyservice.get("/quote/" + id + "/SendToDispatch", {}, true);
  },
  getQuoteById: async function (id) {
    return await carbuyservice.get("/quote/" + id, {}, true);
  },
  getFollowUpQuotes: async function () {
    return await carbuyservice.get("/followup/Open?days=7&&userID=" + StorageManager.getCurrentUser().userID, {}, true);
  },
  getFollowUpQuotesAdmin: async function () {
    return await carbuyservice.get("/followup/Open?days=7", {}, true);
  },
  searchQuotesByPhoneNumber: async function (phoneNumber) {
    return await carbuyservice.get(`/quote/SearchQuotesByPhoneNumber?phoneNumber=${phoneNumber}`, {}, true);
  },
  getWebQuoteQueue: async function () {
    return await carbuyservice.get("/quote/getwebquotequeue", {}, true)
  },
  getInitialQuote: function () {
    return myAPI.get(config.api_root + config.api_root_path_admin + '/quotes/initial')
      .then(function (response) {
        return response
      })
  },
  getAdminQuoteById: async function (id) {
    return await carbuyservice.get("/quote/" + id, {}, true);
  },
  searchQuotesByDate: async function (startDate, endDate) {
    return await carbuyservice.get(`/quote/SearchQuotesByDate?startDate=${startDate}&endDate=${endDate}`, {}, true)
  },
  create: function (data) {
    return new Promise((resolve, reject) => {
      myAPI.post(`${config.api_root + config.api_root_path_admin}/quotes`, data)
        .then(result => {
          resolve(result)
        })
        .catch(err => {
          reject(err);
          this.$store.dispatch("removeLoading");
        })
    })
  },
  searchQuotesByDate: async function (startDate, endDate) {
    return await carbuyservice.get(`/quote/SearchQuotesByDate?startDate=${startDate}&endDate=${endDate}`, {}, true)
  },
  update: async function (data) {
    if (data) {
      console.log(`updating now ... `)
      return await carbuyservice.put(`/quote`, data, true)
      // .then((response) => {
      //   console.log('getting response ...')
      //   return response
      // })
      // .catch((err) => {
      //   console.log('ERROR: ', err);
      //   // this.$store.dispatch("removeLoading");
      // })
    }
  },
  updateAdminOffer: async function (data) {
    return await carbuyservice.put("/offer", data, true)
  }
}



// WEBPACK FOOTER //
// ./src/api/quote.js